import { Project } from '../types';

export const holozing_dec_compare: Project = {
  id: 'holozing-dec-compare',
  title: 'Holozing DEC Compare',
  description: 'HoloDust on Holozing Winning Compare in December',
  longDescription: 'A competitive comparison tool for Holozing players to track their earnings and rank against friends during the critical December HoloDust phase. Built with Hive-Engine API integration for real-time data accuracy.',
  image: 'https://images.hive.blog/0x0/https://files.peakd.com/file/peakd-hive/louis88/23vhVs2ppUzvmwEGmLWqbiL1NVZGaToeHQBkyA8wes29Ct3XVB8GaUJkAoA6sA5HbxrnQ.png',
  tags: ['Gaming', 'Holozing', 'Hive-Engine', 'Tools'],
  link: 'https://louis-88.github.io/HolozingDecCompare/',
  github: 'https://github.com/louis-88/HolozingDecCompare',
  announcementUrl: 'https://peakd.com/hive-131131/@louis88/holo-dust-december-earnings-compare-yourself-with-your-friends',
  featured: true
};
